export const ShieldTickIcon = () => (
    <svg
        width='24'
        height='25'
        viewBox='0 0 24 25'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M10.4899 2.73006L5.49991 4.61006C4.34991 5.04006 3.40991 6.40006 3.40991 7.62006V15.0501C3.40991 16.2301 4.18991 17.7801 5.13991 18.4901L9.43991 21.7001C10.8499 22.7601 13.1699 22.7601 14.5799 21.7001L18.8799 18.4901C19.8299 17.7801 20.6099 16.2301 20.6099 15.0501V7.62006C20.6099 6.39006 19.6699 5.03006 18.5199 4.60006L13.5299 2.73006C12.6799 2.42006 11.3199 2.42006 10.4899 2.73006Z'
            stroke='#0088B2'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M9.05005 12.3699L10.66 13.9799L14.96 9.67993'
            stroke='#0088B2'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </svg>
);
